import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import SearchCreatedToast from '../components/SearchCreatedToast';
import actions from '../constants';

export function* newSearchToast({ result }) {
  yield call(showToast, <SearchCreatedToast code={result.code} name={result.name} />);
}

export function* editSearchToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* destroySearchToast({ items, silent }) {
  if (!silent) {
    yield call(showToast, <DeletesToast items={items} />);
  }
}

export function* destroySearchErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={items} />);
}

export default function* searchToasts() {
  yield takeEvery(actions.NEW_SEARCH, newSearchToast);
  yield takeEvery(actions.EDIT_SEARCH, editSearchToast);
  yield takeEvery(actions.DESTROY_SEARCH, destroySearchToast);
  yield takeEvery(actions.DESTROY_SEARCH_ERROR, destroySearchErrorToast);
}
